module.exports = __webpack_public_path__ + "img/magnetism-rao.0a540641.jpg";